import { uri } from '../../api-endpoint';
import { IAnnotationAPIValidationError } from '../../type-conversion/annotation/from-api-repsonse';
import { IImageInfoListFromAPISuccessResponse } from '../../type-conversion/image-info/from-api-repsonse';
import { ImageInfoAPIRequestBody } from '../../type-conversion/image-info/to-api-request-body';
import { createTemplateFn } from '../common';

export const createModelImage = (token: string) => (modelId: number) =>
  createTemplateFn(
    token,
    uri.modelImageList(modelId),
    ImageInfoAPIRequestBody,
    IImageInfoListFromAPISuccessResponse,
    IAnnotationAPIValidationError
  );
